import React, { createContext, useEffect, useMemo, useState, useContext } from 'react';

const LanguageContext = createContext();
const LANGUAGE_STORAGE_KEY = 'site_language';
const SUPPORTED_LANGUAGES = ['EN', 'ES', 'PT'];

function getInitialLanguage() {
    if (typeof window === 'undefined') {
        return 'EN';
    }

    const storedLanguage = window.localStorage.getItem(LANGUAGE_STORAGE_KEY);

    if (SUPPORTED_LANGUAGES.includes(storedLanguage)) {
        return storedLanguage;
    }

    const browserLanguage = String(window.navigator.language || '').toUpperCase();

    if (browserLanguage.startsWith('ES')) {
        return 'ES';
    }

    if (browserLanguage.startsWith('PT')) {
        return 'PT';
    }

    return 'EN';
}

export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState(getInitialLanguage);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            window.localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
        }
    }, [language]);

    const setLanguage = (nextLanguage) => {
        if (SUPPORTED_LANGUAGES.includes(nextLanguage)) {
            setLanguageState(nextLanguage);
        }
    };

    const value = useMemo(() => ({ language, setLanguage }), [language]);

    return (
        <LanguageContext.Provider value={value}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => useContext(LanguageContext);
